module.exports = __webpack_public_path__ + "fonts/Red_Hat_Text-500-latin6.db81921.woff2";